var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoJesss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_1973)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.307922,
    width: 45.2205,
    height: 45.2205,
    rx: 9,
    fill: "url(#paint0_linear_58_1973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.582 8.92681C23.9408 8.78255 24.9259 7.56252 24.7803 6.20235C24.636 4.84355 23.416 3.85983 22.0558 4.00409C20.697 4.14835 19.7119 5.36838 19.8575 6.72855C20.0018 8.08735 21.2218 9.07244 22.5806 8.92681H22.582Z",
    fill: "url(#paint1_linear_58_1973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5469 25.0304C20.7571 24.8545 20.9797 24.6732 21.2146 24.4891C20.9879 24.6622 20.764 24.8422 20.5469 25.0304Z",
    fill: "url(#paint2_linear_58_1973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2116 17.0768C34.3072 17.8751 30.1951 19.3081 27.6533 20.3041C27.6259 20.2354 27.5929 20.1654 27.5475 20.1008C27.4637 19.984 27.2577 19.6694 27.0062 19.2792L26.9911 19.2545C26.447 18.4095 25.8151 17.4011 25.3026 16.5547L25.293 16.541C24.1018 14.5694 23.8394 13.9759 23.7885 13.7987C23.7514 13.6695 23.7157 13.5486 23.6814 13.4305C23.4918 12.7861 23.342 12.2778 23.2568 11.3092L23.2321 11.0206L20.1065 10.39L20.057 10.5645L20.002 10.7074C19.91 10.9492 19.8166 11.1979 19.7218 11.4507C19.1736 12.9139 18.5512 14.5722 17.5867 16.1975L17.573 16.2209C17.4067 16.4778 17.2364 16.732 17.0646 16.9765C16.5453 17.7184 15.9751 18.4384 15.3775 19.1075C15.2991 19.1899 15.2181 19.2723 15.137 19.3534L14.9131 19.5746L14.9296 19.5993C12.9827 21.6712 10.6911 23.3844 8.11223 24.6952L6.65039 25.4384L8.13696 28.3662L9.60155 27.6216C13.1036 25.8424 16.2307 23.3199 18.6501 20.3248L18.6817 20.3083L18.7229 20.2368C19.2574 19.6007 19.7328 18.9453 20.2164 18.1801L20.2603 18.1114C20.6217 17.5604 20.9679 16.9807 21.2935 16.3885C21.7661 17.2115 22.6647 18.6719 23.7377 20.4099C24.0647 20.9389 24.3587 21.4143 24.5827 21.7825C23.3187 22.49 22.1082 23.2979 20.9789 24.1882C20.7453 24.3723 20.5173 24.5564 20.3029 24.7364L20.2796 24.7584L20.2837 24.7542C20.0336 24.9699 19.7795 25.2063 19.5308 25.4549C18.9428 26.0443 18.3767 26.7134 17.8478 27.4457C17.7749 27.546 17.7021 27.6477 17.6307 27.7507C17.4191 28.0544 17.2116 28.3704 17.0165 28.6905C16.4285 29.6467 15.9476 30.6181 15.5863 31.5784C14.5119 34.4252 14.5366 36.9642 15.6564 38.9275L15.6701 38.9508C16.4725 40.3426 17.9783 41.2068 19.5995 41.2068C19.6544 41.2068 19.7108 41.2068 19.7616 41.204C19.921 41.1999 20.0845 41.1876 20.2631 41.1683C20.5145 41.1409 20.7618 41.101 20.9954 41.0502C23.1593 40.5872 25.1721 39.1363 26.8139 36.857C26.8606 36.7924 26.9073 36.7292 26.954 36.6605C28.5505 34.3689 29.607 31.496 29.853 28.7784L29.8612 28.685C29.8695 28.5984 29.8777 28.5036 29.8846 28.4006L29.8942 28.2714L29.8983 28.2234C29.9024 28.1657 29.9066 28.1066 29.9093 28.0379L29.912 27.9857C29.912 27.9692 29.9134 27.9541 29.9148 27.9376C29.9162 27.9032 29.9189 27.8689 29.9189 27.84C29.9244 27.7342 29.9272 27.6216 29.9299 27.5075C29.945 26.8041 29.9038 26.1048 29.8063 25.4302L29.7994 25.3904C29.7911 25.3464 29.7843 25.3011 29.776 25.2612C29.7678 25.2159 29.7595 25.1719 29.7499 25.1293C29.618 24.4671 29.4188 23.8406 29.1152 23.1413C33.1545 21.6245 35.666 20.9348 37.4136 20.502L37.7076 20.4292V16.9422L37.2185 17.0768H37.2116ZM26.5776 28.4789C26.5556 28.718 26.5267 28.9488 26.4924 29.1741C26.4786 29.2703 26.4622 29.3664 26.4443 29.4626L26.4058 29.6646C26.3948 29.7209 26.3838 29.7759 26.3715 29.8322C26.3495 29.9394 26.3248 30.0479 26.2987 30.1551C25.903 31.7941 25.1803 33.4222 24.2612 34.7398C24.2199 34.8003 24.1787 34.858 24.1348 34.9184C23.1414 36.2868 22.0038 37.228 20.8429 37.6401C20.5379 37.7487 20.2287 37.8201 19.9251 37.8531C19.8331 37.8627 19.7437 37.8696 19.6599 37.8723C19.2409 37.8847 18.8548 37.7061 18.6103 37.3846C18.5828 37.3489 18.5567 37.3104 18.5306 37.2678L18.521 37.2486C17.8587 36.0904 17.9714 34.3235 18.8397 32.2709C18.8686 32.1994 18.9002 32.128 18.9331 32.0566C18.9675 31.9783 19.0046 31.8999 19.0431 31.8189C19.0609 31.7804 19.0788 31.7433 19.1008 31.698C19.1681 31.5565 19.2395 31.4163 19.3123 31.2762C19.6407 30.6483 20.0172 30.0355 20.4334 29.4516C20.88 28.8265 21.3677 28.244 21.8458 27.7658C21.9818 27.6298 22.1179 27.5007 22.247 27.3839L22.372 27.274C22.3871 27.2602 22.4009 27.2479 22.4229 27.23C23.5632 26.2271 24.8066 25.334 26.1242 24.5743C26.1448 24.6237 26.1654 24.6759 26.1888 24.7309C26.3275 25.0771 26.4306 25.3574 26.4855 25.5415C26.7301 26.8178 26.6325 27.8964 26.5789 28.4762L26.5776 28.4789Z",
    fill: "url(#paint3_linear_58_1973)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_1973",
    x1: 22.6103,
    y1: 0.307922,
    x2: 22.6103,
    y2: 45.5284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54398E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#361D6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_1973",
    x1: 4.06308,
    y1: 6.46614,
    x2: 43.4228,
    y2: 6.46614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60BFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#79D7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#8CE995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93F090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_58_1973",
    x1: 6.64703,
    y1: 24.7597,
    x2: 6.78442,
    y2: 24.7597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60BFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#79D7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#8CE995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93F090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_58_1973",
    x1: 6.64764,
    y1: 25.797,
    x2: 6.78503,
    y2: 25.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60BFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#79D7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#8CE995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93F090"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_1973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.2205,
    height: 45.2205,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJesss);
export default __webpack_public_path__ + "static/media/Logo_jesss.1b90eaaa0b7f1bf05d7223a22e17e954.svg";
export { ForwardRef as ReactComponent };